module.exports = __webpack_public_path__ + "img/Flag_of_Papua_New_Guinea.283d419d.svg";